<template>
  <div class="PlanMixer" :class="{ 'PlanMixer--centered': center }">
    <slot v-if="!plans?.length" name="empty-plans" />
    <slot
      v-for="planGroup of plans"
      v-else
      :key="planGroup.map(p => p.code).join('-')"
      :planGroup="planGroup"
    />
  </div>
</template>

<script setup lang="ts">
import { type Plan } from '@cvo/domain';

defineProps<{
  plans?: Plan[][];
  center?: boolean;
}>();
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;

@layer cvo-ui {
  .PlanMixer {
    display: flex;
    justify-content: start;
    gap: vars.$dimensions-d-14;
    flex-wrap: nowrap;

    &--centered {
      justify-content: center;
    }
  }
}
</style>
